import { navigate } from "gatsby"
import { useContext, useEffect } from "react"

import UserContext from "../context/user.context"

export function usePublicKey() {
  const { publicKey, setPublicKey } = useContext(UserContext)

  useEffect(() => {
    if (!publicKey) {
      navigate("/")
    }
  }, [publicKey])

  return { publicKey, setPublicKey }
}
